var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeaderComponent',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.name !== 'greeting'),expression:"$route.name !== 'greeting'"}]}),_c('router-view',{staticClass:"app"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }